// Styles import
import useTableStore from "./lib/stores/tableStore";
import "./styles/globals.css";

// Components
export { CustomTable } from "./components/CustomTable";
export { Pagination } from "./components/CustomTable/Pagination";
export {
  checkboxColumn,
  actionColumn,
} from "./components/CustomTable/DefaultColumns";

// Utils
export { cn } from "./lib/utils";

// Types
export type {
  ColumnDef,
  ColumnFiltersState,
  SortingState,
  VisibilityState,
  Table,
  PaginationState,
} from "@tanstack/react-table";

export { useTableStore };

export type { CalendarProps } from "./lib/types/calendar.types";

export type { CustomTableProps } from "./lib/types/table.types";

export type { TableFilter } from "./lib/stores/tableStore";
